import getVWKey from "../../helpers/getVWKey";

const vx = new THREE.Vector3(1, 0, 0);
const vy = new THREE.Vector3(0, 1, 0);
const vz = new THREE.Vector3(0, 0, 1);

let timeout = null;

function saveState(object, rerender = true) {
    const data = Q3.SlideManager.currentSlide.animation[object.uuid];
    const vpType = getVWKey();

    const saveObject = vpType === "sizeSm"
        ? data[vpType] = data[vpType] || {
            position: { x: 0, y: 0, z: 0 },
            scale: { x: 1, y: 1, z: 1 },
            rotation: { x: 0, y: 0, z: 0 }
        }
        : data;

    vx.set(1, 0, 0).applyQuaternion(object.quaternion);
    vy.set(0, 1, 0).applyQuaternion(object.quaternion);
    vz.set(0, 0, 1).applyQuaternion(object.quaternion);

    const rotX = Math.atan2(vy.z, vy.y);
    const rotY = Math.atan2(vz.x, vx.x);

    saveObject.rotation.x = rotX;
    saveObject.rotation.y = rotY;
    saveObject.rotation.z = 0;

    saveObject.scale.x = object.scale.x;
    saveObject.scale.y = object.scale.y;
    saveObject.scale.z = object.scale.z;

    saveObject.position.x = object.position.x;
    saveObject.position.y = object.position.y;
    saveObject.position.z = object.position.z;

    if (!timeout && rerender) {
        timeout = setTimeout(function () {
            Q3.Events.fire("reRenderComponent");
            timeout = null;
        }, 100);
    }
}

export default saveState;
export { saveState };
